<nb-layout>
    <nb-layout-column class="layout-disconnected">
        <router-outlet></router-outlet>
    </nb-layout-column>
</nb-layout>